import api from "@/store/api";
import {randomString} from "@/utils";
import router from "@/router";

export const csrfToken = 'csrf';
export const browserId = 'hash';

export const token = () => {
    return localStorage.getItem(csrfToken);
};

export const browserHash = () => {
    return localStorage.getItem(browserId);
};

const emptyState = () => {
    return {
        loading: false,
        loadingUser: false,
        currentAccountingDate: null,
        profile: null,
        profileInfo: null,
        assignedToMe: [],
        tempUser: {},
        assignedToSomeone: []
    }
}

export default {
    namespaced: true,
    state: emptyState(),
    getters: {},
    actions: {
        login(store: any, params: any) {
            store.dispatch('deleteStore');
            return new Promise((resolve, reject) => {
                store.commit('loading', true);
                params.hash = localStorage.getItem(browserId);
                api.postWithNotification(store, 'account/login', params, 'Boli ste úspešne prihlásený!').then((response: any) => {
                    store.commit('setToken', response.status);
                    resolve();
                }).catch(() => {
                    store.commit('loading', false);
                    reject();
                });
            });
        },
        switchUser(store: any, params: any) {
            return new Promise((resolve, reject) => {
                store.commit('loading', true);
                params.hash = localStorage.getItem(browserId);
                api.post('account/switch-user', params).then((data: any) => {
                    store.dispatch('deleteStore').then(() => {
                        window.location.reload();
                        resolve();
                    });
                }).catch(() => {
                    store.commit('loading', false);
                    reject();
                });
            });
        },
        get(store: any) {
            store.commit('loading', true);
            return new Promise((resolve, reject) => {
                api.get('account?hash=' + browserHash()).then(data => {
                    store.commit('setProfile', data.data);
                    store.commit('loading', false);
                    resolve(data.data);
                }).catch(error => {
                    store.commit('setProfile', null);
                    store.commit('loading', false);
                    reject();
                });
            });
        },
        getCurrentAccountingDate(store: any) {
            return new Promise((resolve, reject) => {
                api.get('account/get-current-accounting-date').then(data => {
                    store.commit('setAccountingDate', data.data.date);
                    resolve(data.data);
                }).catch(error => {
                    store.commit('setAccountingDate', null);
                    reject();
                });
            });
        },
        getProfileInfo(store: any) {
            store.commit('loading', true);
            return new Promise((resolve, reject) => {
                api.get('account/get-profile-info').then(data => {
                    store.commit('setProfileInfo', data.data);
                    store.commit('loading', false);
                    resolve(data.data);
                }).catch(error => {
                    store.commit('setProfileInfo', null);
                    store.commit('loading', false);
                    reject();
                });
            });
        },
        assignedToMe(store: any) {
            store.commit('loadingUser', true);
            api.get('account/assigned-to-me').then(data => {
                store.commit('setAssignedToMe', data.data);
                store.commit('loadingUser', false);
            }).catch(error => {
                store.commit('setAssignedToMe', []);
            });
        },
        assignedToSomeone(store: any) {
            api.get('account/assigned-to-someone').then(data => {
                store.commit('setAssignedToSomeone', data.data);
            }).catch(error => {
                store.commit('setAssignedToSomeone', []);
            });
        },
        logout(store: any) {
            return new Promise((resolve, reject) => {
                api.postWithNotification(store, 'account/logout', 'Boli ste úspešne odhlásený!').then(response => {
                    store.dispatch('deleteStore');
                    resolve();
                });
            });
        },
        changePassword(store: any, params: any) {
            return new Promise((resolve, reject) => {
                store.commit('loading', true);
                api.putWithNotification(store, 'account/change-password', params, 'Vaše heslo bolo zmenené!').then(response => {
                    store.commit('loading', false);
                    store.dispatch('alert/success', 'Password was changed', {root: true});
                    resolve()
                }).catch(error => {
                    store.commit('loading', false);
                    store.dispatch('alert/error', error.response.data.status, {root: true});
                    reject()
                });
            });
        },
        updateProfile(store: any, params: any) {
            api.putWithNotification(store, 'account/update-profile', params, 'Žiadosť o zmenu údajov bola odoslaná!');
        },
        lostPassword(store: any, params: any) {
            return api.postWithNotification(store, 'account/lost-password', params, 'E-mail s odkazom na zmenu hesla bol odoslaný!');
        },
        validateToken(store: any, params: any) {
            return new Promise((resolve, reject) => {
                api.get('account/get-lost-password/' + params.id + '/' + params.hash).then(() => {
                    resolve();
                }).catch((error) => {
                    store.dispatch('alert/error', 'Neplatný token!', {root: true});
                    router.push({name: 'login'});
                });
            });
        },
        resetPassword(store: any, params: any) {
            return api.putWithNotification(store, 'account/reset-password/' + params.id + '/' + params.hash, params, 'Heslo bolo úspešne zmenené!').then(() => {
                store.dispatch('alert/success', 'Heslo bolo úspešne zmenené!', {root: true});
                router.push({name: 'login'});
            });
        },
        sendPinCodeAgain(store: any) {
            return api.postWithNotification(store, 'account/send-pin-code-again/' + browserHash(), {}, 'Pin kód bol odoslaný!');
        },
        activate(store: any, params: any) {
            return api.postWithNotification(store, 'account/activate/' + browserHash(), params, 'Pin kód bol overený!');
        },
        newTradeRequest(store: any, params: any) {
            return api.putWithNotification(store, 'account/new-trade-request', params, 'Žiadosť bola úspešne odoslaná!');
        },
        newTransactionRequest(store: any, params: any) {
            return api.putWithNotification(store, 'account/new-transaction-request', params, 'Žiadosť bola úspešne odoslaná!');
        },
        deleteStore(store: any) {
            store.commit('reset');
            store.commit('assets/reset', [], { root: true });
            store.commit('content/reset', [], { root: true });
            store.commit('exports/reset', [], { root: true });
            store.commit('message/reset', [], { root: true });
            store.commit('portfolio/reset', [], { root: true });
            store.commit('transactions/reset', [], { root: true });
        }
    },
    mutations: {
        setAccountingDate(state: any, data: any) {
            state.currentAccountingDate = data;
        },
        setAssignedToMe(state: any, items: any) {
            state.assignedToMe = items;
            const result = state.assignedToMe.filter((user: { chosen: any; }) => {
                return user.chosen;
            })
            state.tempUser = result[0];
        },
        setAssignedToSomeone(state: any, items: any) {
            state.assignedToSomeone = items;
        },
        loading(state: any, status: boolean) {
            state.loading = status;
        },
        loadingUser(state: any, status: boolean) {
            state.loadingUser = status;
        },
        setToken(state: any, token: string) {
            localStorage.setItem(csrfToken, token);
        },
        removeToken() {
            localStorage.removeItem(csrfToken);
        },
        setProfile(state: any, profile: any) {
            state.profile = profile;
        },
        setProfileInfo(state: any, profile: any) {
            state.profileInfo = profile;
        },
        initBrowser() {
            if (browserHash() === null) {
                localStorage.setItem(browserId, randomString(50));
            }
        },
        reset (state: any) {
            Object.assign(state, emptyState());
        }
    }
};
